import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoTransactions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 50,
	viewBox: "0 0 70 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 11.9565,
			width: 57.6087,
			height: 38.0435,
			rx: 5,
			fill: "#EDF2F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.957 0C14.1956 0 11.957 2.23858 11.957 5V7.60875H57.9569C60.166 7.60875 61.9569 9.39961 61.9569 11.6088V38.0435H64.5657C67.3272 38.0435 69.5657 35.8049 69.5657 33.0435V5C69.5657 2.23858 67.3271 0 64.5657 0H16.957Z",
			fill: "#C8D0D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 29.3481,
			cy: 31.5214,
			r: 10.8696,
			fill: "#C8D0D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5078 34.8546L32.5685 28.7939",
			stroke: "white",
			strokeWidth: 2.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5058 28.7939L32.5664 34.8546",
			stroke: "white",
			strokeWidth: 2.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNoTransactions;
